import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.2.0-canary.23_@babel+core@7.24.5_@opentelemetry+api@1.9.0_babel-plugin-react-compiler_b5xqfpo7gijlklyonndxb3bgyy/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.0-canary.23_@babel+core@7.24.5_@opentelemetry+api@1.9.0_babel-plugin-react-compiler_b5xqfpo7gijlklyonndxb3bgyy/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CartAsideDrawer"] */ "/vercel/path0/src/app/(store)/cart/cart-aside-drawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartModalProvider"] */ "/vercel/path0/src/context/cart-modal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/christmas.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["Newsletter"] */ "/vercel/path0/src/ui/footer/newsletter.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartLink"] */ "/vercel/path0/src/ui/nav/cart-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavMobileMenu"] */ "/vercel/path0/src/ui/nav/nav-mobile-menu.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchInputPlaceholder","SearchInput"] */ "/vercel/path0/src/ui/nav/search-input.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SeoH1"] */ "/vercel/path0/src/ui/seo-h1.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/ui/shadcn/tooltip.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/ui/yns-link.tsx");
